// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3Wsyi","paramInput":"JobSimulator_paramInput__1CL4_","input":"JobSimulator_input__2KQRm"};